import React from "react";
import Button from "../../../../../../components/Button";

const Component = ({
  setFilter,
  fieldName,
  value,
  filters,
  name,
  special,
}: {
  setFilter;
  fieldName: string | string[];
  value;
  filters;
  name;
  special?;
}) => {
  return (
    <Button
      type="button"
      onClick={() => {
        if (!special) {
          !filters.find(
            (filter) => filter.field === fieldName && filter.value === value
          )
            ? setFilter({ field: fieldName, value: value })
            : setFilter({ field: fieldName, value: "no" });
        } else {
          !filters.find(
            (filter) => filter.field === fieldName && filter.value === value
          )
            ? setFilter({
                field: fieldName,
                value: value,
                [special.name]: special.function,
              })
            : setFilter({ field: fieldName, value: "no" });
        }
      }}
      options={{
        size: "md",
        type: "filled",
        skin: "gray",
      }}
      minwidth="0px"
      style={{
        width: "auto",
        border: "none",
        backgroundColor: "#fff",
        height: "32px",
        color: "rgb(0, 30, 108)",
        padding: "7px 8px 8px",

        borderRadius: "5px",
        ...(!!filters.find(
          (filter) => filter.field === fieldName && filter.value === value
        ) && {
          backgroundColor: "rgb(0, 30, 108)",
          color: "#fff",
        }),
        ...(!filters.find((filter) =>
          Array.isArray(fieldName)
            ? fieldName.includes(filter.field)
            : filter.field === fieldName
        ) &&
          value === "no" && {
            backgroundColor: "rgb(0, 30, 108)",
            color: "#fff",
          }),
      }}
    >
      {name}
    </Button>
  );
};

export default Component;
